export class InfoBarModel {
	icon?: InfoBarIconModel;
	text: string;
	columnWidth?: number;

	constructor() {
		this.text = '';
	}
}

export class InfoBarIconModel {
	class?: string;
	color?: string;
	size?: string;
}
